const topics = [

    {
      title: "Neighbors",
      slug: "neighbors",
      standardNumber: "VS.2",
      description: "Virginia is bordered by five states: North Carolina, Tennessee, Kentucky, West Virginia, and Maryland.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fneighborsvideo.mp4?alt=media&token=f2f9e1f2-faeb-4e01-a2ab-001fafe3e45f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FNEIGHBORS%20(VS.2a).mp3?alt=media&token=1de2f7f3-6424-4604-af8c-8c34b15492db",
      lyrics: ["(chorus)",
"Virginia is surrounded by five states, Virginia is surrounded by five states,",
"Virginia is surrounded by five states, Virginia is surrounded by five states.",

"(verse)",
"Name that state: North Carolina.",
"Name that state: Tennessee.",
"Name that State: Kentucky, West Virginia, and Maryland.",
"Name that state: North Carolina.",
"Name that state: Tennessee.",
"Name that state: Kentucky, West Virginia, and Maryland.",

"(chorus)",
"Virginia is surrounded by five states, Virginia is surrounded by five states.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "VA 5 Regions",
      slug: "va5regions",
      standardNumber: "VS.2",
      description: "Virginia has five regions: the Coastal Plain, Piedmont, Blue Ridge Mountains, Valley and Ridge, and Appalachian Plateau, each with unique landforms.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2F5regionsvideo.mp4?alt=media&token=cf943481-f675-4578-990f-e7e733134425",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FVIRGINIA%205%20REGIONS.mp3?alt=media&token=1bf3e42f-8fa2-4651-b8e5-604810fbe874",
      lyrics: ["(chorus)",
        "Virginia 5 Regions, Virginia 5 Regions.",
        "Virginia 5 Regions, Virginia 5 Regions.",
        "(verse)",
        "Coastal Plain low flat land, Coastal Plain low flat land.",
        "Coastal Plain (Tidewater), low flat land, low flat land.",
        "Piedmont Rolling Hills.",
        "Piedmont Rolling Hills.",
        "Piedmont Rolling Hills.",
        "Piedmont Rolling Hills.",
        "Blue Ridge Mountains are rounded part of the Appalachian Mountains.",
        "Blue Ridge Mountains are rounded part of the Appalachian Mountains.",
        "Valley and Ridge are valleys along the Blue Ridge Mountain.",
        "Valley and Ridge are valleys along the Blue Ridge Mountain.",
        "Appalachian Plateau high lands.",
        "Appalachian Plateau high lands.",
        "Appalachian Plateau high lands.",
        "Appalachian Plateau high lands.",
        "(chorus)",
        "Virginia 5 Regions, Virginia 5 Regions.",
        "Virginia 5 Regions, Virginia 5 Regions.",
        "© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Rivers",
      slug: "rivers",
      standardNumber: "VS.2",
      description: "Virginia’s four major rivers are the Potomac, Rappahannock, York, and James which flow into the Chesapeake Bay and provided food, travel, and exploration routes.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Frivers2025video.mp4?alt=media&token=dfbb0d8a-35c6-4c9d-bece-abe274d84e6a",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Frivers2025song.mp3?alt=media&token=b752c777-2d25-413e-a351-295d39389a8e",
      lyrics: ["(chorus)",
"We can flow like a river.",
"We can flow like a river.",

"The Potomac River,",
"Rappahannock River,",
"James River,",
"York River.",

"(verse)",
"Alexandria, Virginia is along the Potomac River.",
"The Potomac River way flows into the Chesapeake Bay.",

"Fredericksburg, Virginia is along the Rappahannock River.",
"The Rappahannock River way flows into the Chesapeake Bay.",

"Yorktown, Virginia is along the York River.",
"The York River way flows into the Chesapeake Bay.",

"Richmond and Jamestown, Virginia are along the James River.",
"The James River way flows into the Chesapeake Bay.",

"Each river provided food.",
"Each river provided a pathway for exploration.",

"(chorus)",
"We can flow like a river.",
"We can flow like a river.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Languages",
      slug: "languages",
      standardNumber: "VS.2",
      description: "Different Virginia regions had distinct Native languages and tribes, with the Cherokee speaking Iroquoian in the Valley and Ridge, the Monacan speaking Siouan in the Piedmont, and the Powhatan speaking Algonquian in the Tidewater.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Flanguagesvideo.mp4?alt=media&token=b7508811-da66-46f6-aefe-8d80ca91a047",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FVIRGINIA%20LANGUAGES.mp3?alt=media&token=e802ca15-4f3c-4fdb-be80-73f719e479ea",
      lyrics: ["(verse)",
        "In southwestern Virginia,",
"we spoke Iroquoian.",
"In the valley and ridge region,",
"we spoke Iroquoian.",
"Then we moved to the Piedmont region,",
"and there they spoke Siouan.",
"Then we moved to the Piedmont region,",
"and there they spoke Siouan.",
"In the Tidewater region,",
"they spoke Algonquian.",
"In the Tidewater region,",
"they spoke Algonquian.",
"In the valley and ridge region,",
"we were mostly Cherokee.",
"In the Piedmont region,",
"they were mostly Monacan.",
"In the Tidewater region,",
"they were mostly Powhatan.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Surviving Seasons",
      slug: "survivingseasons",
      standardNumber: "VS.2",
      description: "Virginia’s Native peoples survived the seasons by hunting in winter, fishing and gathering in spring, farming in summer, and harvesting and storing food in fall.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fsurvivingseasons2022.mp4?alt=media&token=6b4da363-4ebc-46ae-ace2-4993a44cb1dc",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FSURVIVING%20SEASONS%20(VS.2e).mp3?alt=media&token=09a254e9-ed63-47c6-95cf-65d75dfd8d5f",
      lyrics: ["(verse)",
"In the Winter,",
"we hunted birds.",
"In the Winter,",
"we hunted animals.",

"In the Spring,",
"we fished, hunted and picked berries.",
"In the Spring,",
"we fished, hunted and picked berries.",

"In the Summer we grew crops,",
"beans, corn, and squash.",
"In the Summer we grew crops,",
"beans, corn and squash.",

"In the Fall we picked our crops.",
"We hunted for food to store for the Winter.",
"In the Fall we picked our crops.",
"We hunted for food to store for the Winter.",

"(chorus)",
"How do we survive the Seasons?",
"How do we survive the Seasons?",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "The Past",
      slug: "thepast",
      standardNumber: "VS.2",
      description: "Archaeology helps us learn about the past, with discoveries like Cactus Hill in Virginia showing humans lived there about 18,000 years ago.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthepast2025video.mp4?alt=media&token=7795bf40-80aa-4051-8ae3-c6625c16bcd9",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthepast2025song.mp3?alt=media&token=e3700f5a-9a49-4338-8eb7-881e141068d4",
      lyrics: ["(chorus)",
"To learn about the past, we use archaeology.",
"People who study the past are archaeologist.",
"To learn about the past, we use archaeology.",
"People who study the past are archaeologist.",

"(verse)",
"Archaeologist study things that were made in the past.",
"They’ve discovered evidence",
"about Cactus Hill in southeastern Virginia.",
"It’s one of the oldest sites in North America.",
"18,000 years ago, we believe humans lived at Cactus Hill.",
"18,000 years ago, we believe humans lived at Cactus Hill.",

"(chorus)",
"To learn about the past, we use archaeology.",
"People who study the past are archaeologist.",
"To learn about the past, we use archaeology.",
"People who study the past are archaeologist.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Tribes Today",
      slug: "tribestoday",
      standardNumber: "VS.2",
      description: "Virginia recognizes several Native tribes today including the Monacan in the Piedmont and seven others in the Coastal Plain such as the Chickahominy, Mattaponi, Nansemond, Pamunkey, and Rappahannock.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftribestoday2022.mp4?alt=media&token=c868d90f-10c3-48c5-9196-0143dbd9f75c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FTRIBES%20TODAY%20(VS.2g).mp3?alt=media&token=b9411102-6bd1-4094-a4e5-7a2c3df906e4",
      lyrics: ["(chorus)",
"For thousands of years Natives lived in Virginia.",
"For thousands of years Natives lived in Virginia.",
"How many tribes today does Virginia Recognize? 8.",
"How many tribes today does Virginia Recognize? 8.",
"(Verse)",
"The Monacan tribe in the Piedmont Region.",
"The other seven tribes are in The Coastal Plain (Tidewater) Region.",
"The Chickahominy Tribe,",
"The Eastern Chickahominy Tribe,",
"The Mattaponi Tribe,",
"The Upper Mattaponi Tribe,",
"The Nansemond Tribe,",
"The Pamunkey Tribe,",
"and The Rappahannock Tribe,",
"and The Rappahannock Tribe,",
"For thousands of years Natives lived in Virginia.",
"For thousands of years Natives lived in Virginia.",
"(chorus)",
"For thousands of years Natives lived in Virginia.",
"For thousands of years Natives lived in Virginia.",
"How many tribes today does Virginia Recognize? 8.",
"How many tribes today does Virginia Recognize? 8."],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Settled",
      slug: "settled",
      standardNumber: "VS.3",
      description: "In 1607 the English settled Jamestown to gain wealth and power, seeking gold, raw materials, and new markets with support from the Virginia Company of London.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettled2022.mp4?alt=media&token=ccafb686-6eab-4cfe-b145-0fd1c3cf81b8",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettled2025song.mp3?alt=media&token=c0f9efb7-febe-47bd-b658-311e40b076ad",
      lyrics: ["(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"(Verse)",
"The Virginia Company of London’s stockholders,",
"Paid for the settlement.",
"They settled on a peninsula, surrounded on three sides by the James River.",
"The area was good for trade.",
"From the Spanish, they thought they were safe.",
"From the Spanish, they thought they were safe.",
"Their ships could come in to dock.",
"They thought their water supply was good.",

"(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Location",
      slug: "location",
      standardNumber: "VS.3",
      description: "Jamestown was founded on a peninsula in 1607 because settlers believed it had fresh water, deep shores for ships, and protection from sea attacks.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Flocation2022.mp4?alt=media&token=68fe4786-d562-4df5-b68c-f48c95fb5ea0",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FLOCATION%20(VS.3b).mp3?alt=media&token=49f55b79-2e84-4899-b9cc-f883f15c48fe",
      lyrics: ["(chorus)",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula.",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula.",
"Why choose this location? Why choose this location?",
"Because, because, because, because…",
"(verse)",
"They thought that this area had a good supply of fresh water.",
"Along the shore the water was deep enough for the ships to pull in.",
"They thought that this location could easily be defended",
"against attack from the sea.",
"They thought that this location could easily be defended",
"against attack from the sea.",
"(chorus)",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula.",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Charters",
      slug: "charters",
      standardNumber: "VS.3",
      description: "The King of England granted charters to the Virginia Company of London, giving them the right to establish settlements and outlining laws for the people.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fcharters2022.mp4?alt=media&token=9a795227-7a84-4231-b703-1e62809ec589",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcharters2025song.mp3?alt=media&token=82c3b635-216b-4e3c-95ed-07168e29ea3f",
      lyrics: ["(chorus)",
"Charters were granted by the King of England",
"for the settlement in North America.",
"Charters were granted by the King of England",
"for the settlement in North America.",

"(verse)",
"Charters were granted to the Virginia Company of London",
"to establish a settlement in North America.",
"Charters were granted to the Virginia Company of London",
"to establish a settlement in North America.",
"A charter is a document that states the rights and laws for the people,",
"a charter is a document that states the rights and laws for the people.",

"(chorus)",
"Charters were granted by the King of England",
"for the settlement in North America.",
"Charters were granted by the King of England",
"for the settlement in North America.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "General Assembly",
      slug: "generalassembly",
      standardNumber: "VS.3",
      description: "The General Assembly began in 1619 with the governor, council, and burgesses, later forming the House of Burgesses as the first elected legislative body in Virginia.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fgeneralassembly2022.mp4?alt=media&token=343bd143-587d-44cf-91e5-1391234c3246",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FGENERAL%20ASSEMBLY%20(VS.3d).mp3?alt=media&token=e446f867-8b49-442a-9871-ceed93d41398",
      lyrics: ["(verse)",
"The General Assembly 1619,",
"The General Assembly 1619,",
"The General Assembly 1619.",
"The Governor,",
"The Governors council,",
"Two representatives of each",
"of the divisions of Virginia,",
"called Burgesses,",
"called Burgesses.",
"The General Assembly,",
"The General Assembly.",
"Around 1640, The Burgesses separated",
"and became its own body of legislation,",
"called The House of Burgesses.",
"They were elected by the settlers,",
"called The House of Burgesses.",
"They were elected by the settlers.",
"House of Burgesses,",
"House of Burgesses,",
"House of Burgesses,",
"House of Burgesses.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "The Arrival",
      slug: "thearrival",
      standardNumber: "VS.3",
      description: "In 1619 African men and women arrived in Jamestown, contributing as slaves or servants and helping tobacco farming and family settlement grow.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthearrival2022.mp4?alt=media&token=bdba34f5-7e5d-4632-a4c7-c58dc067f315",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FTHE%20ARRIVAL%20(VS.3e).mp3?alt=media&token=75280ffa-9981-44e1-a942-27481d719218",
      lyrics: ["(chorus)",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",

"(verse)",
"They had an impact on the way things were going,",
"they were slaves or servants.",
"They helped the tobacco business grow,",
"and more women made it possible for families to settle.",
"In Jamestown, in Jamestown,",
"in Jamestown, in Jamestown.",

"(chorus)",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Hard Living",
      slug: "hardliving",
      standardNumber: "VS.3",
      description: "Jamestown settlers struggled with disease, starvation, and unsafe water until supply ships and John Smith’s leadership helped the colony survive.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fhardliving2025video.mp4?alt=media&token=86619e66-6300-4fcc-b6d5-7249b40d7c51",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FHARD%20LIVING%20(VS.3f).mp3?alt=media&token=c8f4ad9f-a0dc-4c8f-ab21-9d32d75d57f0",
      lyrics: ["(chorus)",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",

"(verse)",
"Many settlers died of starvation.",
"Many settlers died from disease.",
"The area that they chose to settle in was marshy,",
"and they did not have much safe water to drink.",
"So supply ships came in",
"led by John Smith the Captain,",
"they would work hard and do a lot of farming",
"for the colony to survive.",

"(chorus)",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Settlers & Natives",
      slug: "settlersandnatives",
      standardNumber: "VS.3",
      description: "Jamestown settlers and the Powhatan Natives traded goods, shared farming skills, and relied on Pocahontas and Chief Powhatan for communication and survival.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettlersandnatives2025video.mp4?alt=media&token=940c1422-225d-40ff-a542-7ccacad270ab",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettlersandnatives2025song.mp3?alt=media&token=a5db0c94-fba2-4bf5-b284-0bac1d75da7b",
      lyrics: ["(chorus)",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",

"(verse)",
"The settlers learned survival skills",
"from Chief Powhatan.",
"The settlers used Pocahontas as a contact,",
"daughter of Chief Powhatan.",
"The settlers learned how to plant corn",
"from the Natives.",
"The settlers learned how to plant corn",
"from the Natives.",
"The Natives traded with the English for tools and copper.",
"The Natives traded with the English for tools and copper.",
"Trade with the Natives began with Captain John Smith.",

"(chorus)",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Cash Crop",
      slug: "cashcrop",
      standardNumber: "VS.4",
      description: "Plantations in Virginia grew tobacco as a cash crop, using it like money and relying on the labor of enslaved African men, women, and children.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcashcrops2025video.mp4?alt=media&token=b9e41c1b-30ab-4c73-96bf-5ce6d6041492",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcashcrops2025song.mp3?alt=media&token=efcc1137-a1a4-4040-9d13-0106a0b5321c",
      lyrics: ["(chorus)",
"Farming was very important to me.",
"I used my crops as money.",
"Farming was very important to me.",
"I used my crops as money.",
"They’re called cash crops, cash crops, cash crops.",
"They’re called cash crops, cash crops, cash crops.",

"(verse)",
"If we can find cheap labor,",
"we can make a lot of money planting tobacco.",
"If we can find cheap labor,",
"we can make a lot of money planting tobacco.",
"So African men, women and children were brought in",
"to work as slaves on the plantation.",
"African men, women and children were brought in",
"to work as slaves on the plantation.",

"(chorus)",
"Farming was very important to me.",
"I used my crops as money.",
"Farming was very important to me.",
"I used my crops as money.",
"They’re called cash crops, cash crops, cash crops.",
"They’re called cash crops, cash crops, cash crops.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Old Ways",
      slug: "oldways",
      standardNumber: "VS.4",
      description: "European and African settlers in Virginia brought their own beliefs, customs, and architecture that influenced the new environment.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Foldways2022.mp4?alt=media&token=fad7b055-9433-4051-93ec-939bc771ff4a",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FOLD%20WAYS%20(VS.4b).mp3?alt=media&token=fa464f6c-10dc-4d9c-8093-0947c0547741",
      lyrics: ["(verse)",
"When settlers settled in a new environment,",
"they tend to bring their old customs with them,",
"Even though they settled in Virginia, North America,",
"Europeans brought their beliefs, customs, and architecture,",
"When settlers settled in a new environment,",
"they tend to bring their old customs with them,",
"Even though they settled in Virginia, North America,",
"Europeans brought their beliefs, customs, and architecture,",
"When settlers settled in a new environment,",
"they tend to bring their old customs with them,",
"Even though they settled in Virginia, North America,",
"Africans brought their beliefs, customs, and architecture,",
"When settlers settled in a new environment,",
"they tend to bring their old customs with them,",
"Even though they settled in Virginia, North America,",
"Africans brought their beliefs, customs, and architecture,",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Moving Capital",
      slug: "movingcapital",
      standardNumber: "VS.4",
      description: "Virginia’s capital moved from Jamestown to Williamsburg because of unhealthy conditions and later to Richmond for a central location and protection from British attack.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fmovingcapital2022.mp4?alt=media&token=18075d5d-b411-4389-84fb-588b09f1e4f6",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FMOVING%20CAPITAL%20(VS.4c).mp3?alt=media&token=f9cba462-caa8-4f2e-81c2-79ff99850236",
      lyrics: ["(chorus)",
"Let's make that move from Jamestown,",
"Move the Capital to Williamsburg, Virginia,",
"Let's make that move from Jamestown,",
"Move the Capital to Williamsburg, Virginia,",

"(verse)",
"Reasons:,",
"Unhealthy conditions in Jamestown caused diseases,",
"Drinking water was contaminated by saltwater seepage,",
"Reasons:,",
"Unhealthy conditions in Jamestown caused diseases,",
"Drinking water was contaminated by saltwater seepage,",

"(chorus)",
"Let's make that move from Jamestown,",
"Move the Capital to Williamsburg, Virginia,",
"Let's make that move from Jamestown,",
"Move the Capital to Williamsburg, Virginia,",

"(verse)",
"Reasons:,",
"Richmond was more of a central location for the capital,",
"Richmond increased the distance from attack by the British,",
"by the British,",
"The state capital moved from Jamestown to Williamsburg Virginia,",
"The state capital moved from Williamsburg to Richmond Virginia,",

"(chorus)",
"Let's make that move from Jamestown,",
"Move the Capital to Williamsburg, Virginia,",
"Let's make that move from Jamestown,",
"Move the Capital to Williamsburg, Virginia,",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Barter",
      slug: "barter",
      standardNumber: "VS.4",
      description: "In colonial Virginia most people bartered goods and services, often using tobacco as a form of money.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbarter2025video.mp4?alt=media&token=6345df74-466e-458e-b8c2-923c150215eb",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbarter2025song.mp3?alt=media&token=8ac562f6-6b71-49da-9b5c-7044b49d009a",
      lyrics: ["(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"(verse)",
"Most people did not have paper money.",
"Most people did not have coins.",
"Most people did not have paper money.",
"Most people did not have coins.",

"(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"(verse)",
"Barter means trading, barter means trading,",
"Or exchanging of goods without using money.",
"Tobacco was used as money.",
"You could trade tobacco for goods and services.",

"(chorus)",
"As a farmer, I would barter.",
"As a farmer, I would barter.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Resources",
      slug: "resources",
      standardNumber: "VS.4",
      description: "In Colonial Virginia people used available resources for food, housing, and clothing, relying on local produce, simple homes, and materials like cotton, wool, and leather.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fresources2022.mp4?alt=media&token=bbbe8fe8-50cf-4d25-9042-06b00c9b259b",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FRESOURCES%20(VS.4e).mp3?alt=media&token=9bb46bae-2f81-46f3-9fd6-c3766a0d81e7",
      lyrics: ["(chorus)",
"We used resources that were available in Colonial Virginia,",

"(verse)",
"When it came down to food our choices were limited but still,",
"we used local produce and meats to make our meals,",
"Some farmers lived in larger houses, while most people lived in one room homes,",
"We made our own clothes out of cotton, wool, and leather,",

"(chorus)",
"We used resources that were available in Colonial Virginia,",
"We used resources that were available in Colonial Virginia,",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Believe",
      slug: "believe",
      standardNumber: "VS.5",
      description: "The conflict over “no taxation without representation” showed how Parliament and the colonists disagreed about authority and the right to tax.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbelieve2025video.mp4?alt=media&token=739fef43-17be-4fe3-800f-dbdc505908f7",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbelieve2025song.mp3?alt=media&token=045a13ac-c4a8-4547-86eb-abf8a1688c35",
      lyrics: ["(chorus)",
"No taxation without representation.",
"British Parliament and the colonists",
"had different ideas about government.",
"No taxation without representation.",
"British Parliament and the colonists",
"had different ideas about government.",

"(verse)",
"Parliament believed that it had legal authority in the colonies.",
"The colonists believed that their local assembly had legal authority.",
"Parliament believed that it had the right to put taxes on the colonies.",
"The colonists believed since no one in parliament represents the colonists",
"they should not be taxed.",

"(chorus)",
"No taxation without representation.",
"British Parliament and the colonists",
"had different ideas about government.",
"No taxation without representation.",
"British Parliament and the colonists",
"had different ideas about government.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Sides",
      slug: "sides",
      standardNumber: "VS.5",
      description: "During the Revolutionary War some Virginians were patriots fighting for independence, some were loyalists supporting Great Britain, and others stayed neutral.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fsides2022.mp4?alt=media&token=0f6c66b2-20fd-48b6-9b18-95d41a5d708b",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FSIDES%20(VS.5b).mp3?alt=media&token=ec23f71b-1c66-4e21-94a9-add7c2790d48",
      lyrics: ["(chorus)",
"Patriots, neutrals, and loyalist,",
"Patriots, neutrals, and loyalist,",

"(verse)",
"During the Revolutionary War,",
"you had patriots, neutrals, and loyalist,",
"Patriots were Virginians in the Continental Army,",
"They fought for Independence,",
"Neutrals were Virginians who did not take sides",
"with the Continental Army or Great Britain,",
"Loyalist were Virginians,",
"They stayed loyal to Great Britain,",

"(chorus)",
"Patriots, neutrals, and loyalist,",
"Patriots, neutrals, and loyalist,",
"Patriots, neutrals, and loyalist,",
"Patriots, neutrals, and loyalist,",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Battles",
      slug: "battles",
      standardNumber: "VS.5",
      description: "Virginia saw key Revolutionary War battles, with the American victory at Great Bridge driving out the British governor and the Battle of Yorktown leading to the British surrender.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbattles2025video.mp4?alt=media&token=4624a3e5-229d-4314-815f-7c9d8917c041",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbattles2025song.mp3?alt=media&token=4711cd0b-5865-4465-8a8c-7a9a2aa6465a",
      lyrics: ["(verse)",
"During the American Revolution,",
"The first land battle fought in Virginia",
"Was the Battle of Great Bridge,",
"Was the Battle of Great Bridge.",

"The British colonial governor was forced",
"To leave the city of Norfolk",
"In the Battle of Great Bridge,",
"In the Battle of Great Bridge.",

"The American victory",
"Forced the British governor to flee",
"In the Battle of Great Bridge,",
"In the Battle of Great Bridge.",

"Now the Battle of Yorktown,",
"The Battle of Yorktown,",
"The Battle of Yorktown,",
"The Battle of Yorktown.",

"The last major battle of the Revolutionary War",
"Was fought in Yorktown, Virginia.",
"That American victory led to the",
"Surrender of the British army.",
"Then the war was over,",
"The war was over.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Founders",
      slug: "founders",
      standardNumber: "VS.6",
      description: "Important U.S. leaders included George Washington as the first president, Thomas Jefferson who wrote the Virginia Statute for Religious Freedom and helped draft the Declaration of Independence, and Abraham Lincoln who ended slavery as the 16th president.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffounders2025video.mp4?alt=media&token=885d2cec-ff29-403c-bb7d-4c06f1877f42",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffounders2025song.mp3?alt=media&token=6bc11234-83e1-4818-988c-43535c6396d2",
      lyrics: ["(chorus)",
"Can you name some founders of the United States?",
"Yes, yes.",
"Can you name some founders of the United States?",
"Yes, yes.",

"(verse)",
"George Washington is called the father of our country.",
"He was the 1st President of the United States.",
"Thomas Jefferson wrote the Virginia Statue for Religious Freedom,",
"for Religious Freedom.",
"Thomas Jefferson was one of the founders of the",
"Declaration of Independence.",
"Abraham Lincoln was the 16th president,",
"he helped to end slavery.",
"Abraham Lincoln was the 16th president,",
"he helped to end slavery.",

"(chorus)",
"Can you name some founders of the United States?",
"Yes, yes.",
"Can you name some founders of the United States?",
"Yes, yes.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Moving",
      slug: "moving",
      standardNumber: "VS.6",
      description: "After the American Revolution Virginians moved west to find farmland and new opportunities while carrying their ideas, culture, and traditions with them.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fmoving2022.mp4?alt=media&token=54f34227-8e13-4384-befc-58f2a4e3dcdb",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FMOVING%20(VS.6c).mp3?alt=media&token=ddb25efd-6b5a-479c-b7c5-0f80ff419263",
      lyrics: ["(chorus)",
"Virginians started to move west,",
"after the American Revolution,",
"Virginians started to move west,",
"after the American Revolution,",
"(verse)",
"Reasons:",
"To find farmland,",
"and new opportunities that come along with it,",
"As Virginians moved West,",
"they took their ideas, cultures, and traditions,",
"Reasons:",
"To find farmland,",
"and new opportunities that come along with it,",
"As Virginians moved West,",
"they took their ideas, cultures, and traditions,",
"(chorus)",
"Virginians started to move west,",
"after the American Revolution,",
"Virginians started to move west,",
"after the American Revolution.",
"© Smart Board Learning, LLC. All rights reserved."],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Civil War Causes",
      slug: "civilwarcauses",
      standardNumber: "VS.7",
      description: "Events like the Missouri Compromise, Compromise of 1850, Kansas-Nebraska Act, Dred Scott decision, John Brown’s raid, Lincoln’s election, and Southern secession led to the start of the Civil War.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcivilwarcausesvideo2025video.mp4?alt=media&token=69b4383b-f123-493d-9d39-0d4a1722c62e",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcivilwarcauses.mp3?alt=media&token=90ff70f4-0eda-4958-9de4-c7eea6aa89b9",
      lyrics: ["That took us to war, took us to war, took us to war.",

"[verse1]",
"The Missouri Compromise of 1820, Missouri Compromise of 1820.",
"This law created an imaginary line through the Louisiana territory.",
"All states north would be free states.  All states south would be slave states.",
"This worked until 1850, when California asked to be",
"part of the United States.  This upset the balance of free and slave states.",
"Then came the Compromise of 1850,",
"allowing territories to decide on slavery.",
"The North had to obey the slave law fugitive (Fugitive Slave Law)",
"A law the put California to the Union.",
"The Fugitive Slave Law required police in free states",
"to help capture escaped slaves.",
"And free Americans can be caught and sold into slavery, sold into slavery.",
"The Kansas and Nebraska act, act.",
"1854, law, law.",
"Allowed Kansas and Nebraska territories to decide if they want slavery.",
"Then came Dred Scott.",
"1857 decision from Supreme Court.",
"Dred Scott was enslaved.",
"Asked the court for his freedom since his owner lived in a free state.",
"The court said no, he was private property",
"and the owner can take anywhere, his private property.",
"Then came the John Brown raid.",
"When John Brown and his followers invaded",
"a building in Virginia, that was used to store government weapons.",
"They were all arrested.",
"John Brown was an abolitionist with hopes to rebel, end slavery with his actions.",

"That took us to war, took us to war, took us to war.",

"[chorus]",
"Many things, like political things, slavery things, expansion things, economic things.",
"That took us to war, took us to war, took us to war.",

"[verse2]",
"The election of 1860, they knew Abraham Lincoln stood against slavery.",
"During this election he was the only candidate out of four that stood against slavery.",
"Lincoln agreed if he was President, he’d leave slavery alone where it already exists.",
"The problem was, if no new states became slave states, government majority would go to the free states.",
"In the south, this angered them.",
"They threatened to secede if Lincoln won.",
"By March 1861, Mississippi, Florida, Alabama, Texas, Georgia, and Louisiana,",
"and South Carolina had formed a new country called the Confederate States of America.",
"Known as the confederacy, and Jefferson Davis was picked for their presidency.",
"When Lincoln took office, March 4, 1861, more problems begun.",
"Lincoln promised to occupy and control all federal land in the south.",
"The south said no.",
"In Charleston, South Carolina, The Union army occupied Fort Sumter.",
"Confederate army shot through Sumter’s walls,",
"and that was the first battle of the civil war.",
"After Fort Sumter, North Carolina, Arkansas, Virginia, Tennessee left the union.",
"After Fort Sumter, North Carolina, Arkansas, Virginia, Tennessee left the union.",

"[chorus]",
"Many things, like political things, slavery things, expansion things, economic things.",
"That took us to war, took us to war, took us to war.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Virginia Battles",
      slug: "virginiabattles",
      standardNumber: "VS.7",
      description: "Major Civil War battles in Virginia included Bull Run, Fredericksburg, the fall of Richmond, and Lee’s surrender to Grant at Appomattox in 1865.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fvirginiabattles2021.mp4?alt=media&token=23796ad7-5efa-493b-adf2-39bf0cdf1697",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FVIRGINIA%20BATTLES%20(VS.7b).mp3?alt=media&token=934bdafc-1ab5-4a28-b44e-8f5bba548768",
      lyrics: ["(chorus)",
"These are some battles from the Civil War,",
"that took place in Virginia.",
"These are some battles from the Civil War,",
"that took place in Virginia.",
"(verse)",
"In July 1861,",
"was the first Battle of Bull Run,",
"Led by General Thomas “Stonewall” Jackson,",
"That was the Battle of Manassas,",
"the Confederates won.",
"The battle of Fredericksburg, 1862,",
"General Robert E. Lee defeated The Union.",
"In Richmond during the Civil War in 1864,",
"The Confederate capital fell to General Ulysses S. Grant.",
"Appomattox courthouse in Virginia,",
"is where the Confederate General Robert E. Lee surrendered,",
"in 1865, in 1865,",
"The Confederate General Robert E. Lee surrendered.",
"(chorus)",
"These are some battles from the Civil War,",
"that took place in Virginia.",
"These are some battles from the Civil War,",
"that took place in Virginia.",
"© Smart Board Learning, LLC. All rights reserved."],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Reconstruction",
      slug: "reconstruction",
      standardNumber: "VS.8",
      description: "After the Civil War during Reconstruction Virginia’s economy was devastated, but the Freedmen’s Bureau helped provide food, schools, and medical care for freed African Americans and others.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Freconstruction2022.mp4?alt=media&token=fd18d6c0-f35c-4ea7-906f-cdd9643f6b25",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FRECONSTRUCTION%20(VS.8a).mp3?alt=media&token=6f0ae409-b1e8-4718-8205-242eb4061f3e",
      lyrics: ["(chorus)",
"After the Civil War was the reconstruction period.",
"After the Civil War was the reconstruction period.",
"After the Civil War was the reconstruction period.",
"After the Civil War was the reconstruction period.",

"(verse)",
"During this time the economy was hurting.",
"During this time banks were not open.",
"During this time railroads and bridges were destroyed,",
"and plantations, and crops were also destroyed.",
"To provide food, schools, and medical care",
"to freed African Americans,",
"and others in Virginia,",
"they started the Freedmen’s Bureau.",
"To provide food, schools, and medical care",
"to freed African Americans,",
"and others in Virginia,",
"they started the Freedmen’s Bureau.",

"(chorus)",
"After the Civil War was the reconstruction period.",
"After the Civil War was the reconstruction period.",
"After the Civil War was the reconstruction period.",
"After the Civil War was the reconstruction period.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Jim Crow",
      slug: "jimcrow",
      standardNumber: "VS.8",
      description: "Jim Crow laws enforced racial segregation with unfair voting restrictions and separate schools, restrooms, and public facilities for African Americans and others.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fjimcrow2025video.mp4?alt=media&token=81c74b53-7c02-4697-b54f-fadbab1bb784",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fjimcrow2025song.mp3?alt=media&token=42b1d16b-46ee-4da5-9ad8-3ea386933e48",
      lyrics: ["(chorus)",
"Jim Crow Laws opened doors for",
"racial segregation.",

"(verse)",
"Unfair poll taxes and voting test were made to stop",
"African Americans from voting.",
"Since it was hard to vote, it was hard for African Americans",
"to hold public offices.",
"Laws were made",
"for African Americans to drink from different fountains.",
"Laws were made",
"for African Americans to use different restrooms.",
"Laws were made",
"that had African American children and white children",
"attending different schools, it affected Native Americans too.",

"(chorus)",
"Jim Crow Laws opened doors for",
"racial segregation.",
"Jim Crow Laws opened doors for",
"racial segregation.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Virginia Grew",
      slug: "virginiagrew",
      standardNumber: "VS.8",
      description: "Virginia grew after the Civil War through railroads, agriculture, industry, coal mining, new roads, and the importance of tobacco farming and products.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fvirginiagrew2022.mp4?alt=media&token=ed1c05a5-13b7-4a89-b4c2-353494e98e16",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FVIRGINIA%20GREW%20(VS.8c).mp3?alt=media&token=a980b77c-72d3-49c6-8049-38c454149dcc",
      lyrics: ["(verse)",
"Virginia grew because railroads helped grow Business,",
"Virginia grew because railroads helped grow agriculture,",
"Virginia grew because railroads helped grow industry,",
"Coal was found in Tazewell County,",
"Virginia grew because the need for more roads increased,",
"Virginia grew because tobacco farming was very important,",
"Virginia grew because tobacco products were very important,",
"Virginia grew because…",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Virginia Society",
      slug: "virginiasociety",
      standardNumber: "VS.9",
      description: "In the 20th century Virginia shifted from farming to industry as people moved to cities for jobs, transportation expanded, coal mining grew, and farming declined.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fvirginiasociety2022.mp4?alt=media&token=43adf37e-fdd9-41e4-848f-da224e48f8db",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FVIRGINIA%20SOCIETY%20(VS.9a).mp3?alt=media&token=e9310f4d-c458-4bed-8da6-ce8fcc87a65c",
      lyrics: ["(chorus)",
"Cities in Virginia grew because people moved",
"from rural to urban areas for better job opportunities,",
"Cities in Virginia grew because of developments",
"in transportation (roads, railroads, street cars),",
"Cities in Virginia grew because of coal mining,",
"people moved from the countryside to find jobs,",  

"(verse)",
"Virginia went from a farming society",
"to an industrial society,",
"During the 20th Century farming began to change,",
"farming began to change,",
"Crop prices were low and system of farming",
"were very old, and no longer effective,",  

"(chorus)",
"Cities in Virginia grew because people moved",
"from rural to urban areas for better job opportunities,",
"Cities in Virginia grew because of developments",
"in transportation (roads, railroads, street cars),",
"Cities in Virginia grew because of coal mining,",
"people moved from the countryside to find jobs,",  

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Peace",
      slug: "peace",
      standardNumber: "VS.9",
      description: "Woodrow Wilson promoted world peace as the 28th president, and George C. Marshall created an economic recovery plan to help maintain peace after war.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fpeace2022.mp4?alt=media&token=b60400ee-3e06-4e61-ac32-7f0b2120bf87",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FPEACE%20(VS.9b).mp3?alt=media&token=fb301146-0dd6-467c-a81b-e8a5971c73c0",
     lyrics: ["(chorus)",
"Can we keep the peace?",
"Can we keep the peace?",
"Can we keep the peace?",
"Can we?",
"(verse)",
"Woodrow Wilson in the 20th Century,",
"wrote a plan for world peace.",
"Woodrow Wilson in the 20th Century,",
"wrote a plan for world peace.",
"He was the28th President.",
"He was the28th President,",
"from 1913 to 1921,",
"from 1913 to 1921.",
"We had a military leader named George C. Marshall,",
"George C. Marshall.",
"He made an economic plan that would keep world peace,",
"keep world peace.",
"(chorus)",
"Can we keep the peace?",
"Can we keep the peace?",
"Can we keep the peace?",
"Can we?",
"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Equal",
      slug: "equal",
      standardNumber: "VS.9",
      description: "The Brown v. Board of Education case ended “separate but equal,” leading to massive resistance in Virginia until schools were integrated and civil rights laws were passed.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fequal2025video.mp4?alt=media&token=3ccd9bd6-ff1b-40dd-be55-f09a6e598f0b",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fequal2025song.mp3?alt=media&token=4be5e46a-ad3f-4cf4-a7c2-92e950b20c96",
      lyrics: ["(chorus)",
"Separate but equal, separate but equal,",
"separate but equal, in the schools.",
"Separate but equal, separate but equal,",
"separate but equal, the Supreme Court, in 1954 ruled.",

"(verse)",
"Brown VS. Board of Education",
"brought about massive resistance.",
"The Supreme Court said that all schools must desegregate.",
"That brought a lot of hate.",
"Some schools closed so they would not have to mix races.",
"Virginia's government also showed massive resistance,",
"that was a policy that failed.",
"So, Virginia’s public schools were integrated.",
"They had to mix races.",
"Then, came The Civil Rights movement",
"that helped laws get passed and made racial discrimination illegal.",
"Don't hate, don't discriminate.",
"Don't hate, don't discriminate.",

"(chorus)",
"Separate but equal, separate but equal,",
"separate but equal, in the schools.",
"Separate but equal, separate but equal,",
"separate but equal, the Supreme Court, in 1954 ruled.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Contributions",
      slug: "contributions",
      standardNumber: "VS.9",
      description: "Arthur Ashe, Maggie Walker, L. Douglas Wilder, and Oliver Hill made important social, economic, and political contributions to Virginia in the 20th and 21st centuries.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcontributions2025video.mp4?alt=media&token=8b57a668-ba03-40b3-b0e6-dbd5d42d8943",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcontributions2025song.mp3?alt=media&token=154ecdca-e8a1-481f-b187-eec0aaf4d74a",
      lyrics: ["(chorus)",
"In the 20th and 21st century,",
"who made social contributions to Virginia?",
"In the 20th and 21st century,",
"who made political contributions to Virginia?",
"In the 20th and 21st century,",
"who made economic contributions to Virginia?",

"(verse 1)",
"Author Ashe wrote about social change.",
"Author Ashe spoke about social change.",
"He was the first African American to win",
"a major championship in Men's Singles tennis.",
"Maggie Walker was the first African American woman",
"to become bank president in the U.S.",
"Maggie Walker was the first African American woman",
"to become Bank President in the U.S.",

"(chorus)",
"In the 20th and 21st century,",
"who made social contributions to Virginia?",
"In the 20th and 21st century,",
"who made political contributions to Virginia?",

"(verse 2)",
"L. Douglas Wilder was the first African American",
"elected as a state governor in Virginia.",
"Oliver Hill, a lawyer, a Civil Rights leader,",
"he worked for equal rights of African Americans.",
"Oliver Hill, a lawyer, a Civil Rights leader,",
"he helped with Brown V. Board of Education.",

"(chorus)",
"In the 20th and 21st century,",
"who made social contributions to Virginia?",
"In the 20th and 21st century,",
"who made political contributions to Virginia?",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Grow",
      slug: "grow",
      standardNumber: "VS.10",
      description: "Virginia’s economy is supported by exports like tobacco, coal, and poultry, while improved transportation brings migration and tourism for its history.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fgrow2022.mp4?alt=media&token=c01feaab-161a-4ef6-b030-5c964e9442cd",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FGROW%20(VS.10c).mp3?alt=media&token=07bb411b-8210-44aa-b53a-98334844e0e0",
      lyrics: ["(chorus)",
"With better transportation now a days,",  
"people can migrate into Virginia, into Virginia,",  
"With better transportation now a days,",  
"people can migrate into Virginia, into Virginia,",  

"(verse)",
"Tobacco is a big export for Virginia,",  
"Coal is a big export for Virginia,",  
"Poultry is a big export for Virginia,",  
"for Virginia, for Virginia,",  
"Tourist travel to visit Virginia,",  
"because of the history,",  
"Tourist travel to visit Virginia,",  
"because of the history,",  

"(chorus)",
"With better transportation now a days,",  
"people can migrate into Virginia, into Virginia,",  
"With better transportation now a days,",  
"people can migrate into Virginia, into Virginia,",  

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
    {
      title: "Big Business",
      slug: "bigbusiness",
      standardNumber: "VS.10",
      description: "Virginia’s regions support different industries such as seafood and tourism in the Coastal Plain, tobacco and technology in the Piedmont, farming in the Valley and Ridge, recreation in the Blue Ridge, and coal mining in the Appalachian Plateau.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbigbusiness2025video.mp4?alt=media&token=d81c3a50-edb5-474f-8b46-3bd53a45a4e9",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbigbusiness2025song.mp3?alt=media&token=0d4fefef-911b-4b12-8ae7-605a9e5dd2d9",
      lyrics: ["(Verse)",
"In the Coastal Plain region",
"We have plenty of seafood,",
"We build ships,",
"And in this area, there are a lot of tourists.",

"(Verse)",
"In the Piedmont region",
"We have a lot of tobacco.",
"We make big business out of technology,",
"Textiles, and farming.",

"(Verse)",
"In the Valley and Ridge region",
"We have plenty of apples and poultry.",
"We make a living off of apples and poultry.",
"We do a lot of farming, as you can see.",

"(Verse)",
"In the Blue Ridge region",
"We have a lot of apples.",
"We make business out of recreation,",
"Like skiing, recreation.",

"(Verse)",
"In the Appalachian Plateau",
"We have a lot of coal.",
"Coal mining is big business in this area.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: "",
    },
  
];
export default topics;